import type { NextPage, GetServerSideProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import {
  PageConfig,
  RecommendedDocumentsProps
} from '../../types/page_component_types'
import { getPagePropsBySlug } from '../../utils/get_page_props_by_slug'
import {
  Layout,
  Section,
  ButtonPrimary,
  MarkdownComponent,
  RecommendedDocuments
} from '../../components'
import { Locale } from '../../types/shared_types'

interface JobPageContent {
  meta: {
    title: string
    description: string
  }
  slug: string
  title: string
  jobtype: string
  employer: string
  joblocation: string
  jobdescription: string
  typeformlink: string
}

const JobPage: NextPage<{
  pageContent: JobPageContent
  pageConfig: PageConfig
  recommendations: RecommendedDocumentsProps[]
  availableLocales?: string[]
}> = ({ pageContent, pageConfig, recommendations, availableLocales }) => {
  return (
    <Layout
      config={pageConfig}
      meta={pageContent?.meta}
      slug={pageContent?.slug}
      availableLocales={availableLocales}
    >
      <Section className="flex flex-col">
        <h1 className="mb-0">{pageContent?.title || ''}</h1>
        <p className="text-h6 mb-6">{pageContent?.jobtype || ''}</p>
        <p className="mb-12">
          <span className="font-bold">{pageContent?.employer || ''}</span>,{' '}
          <span>{pageContent?.joblocation || ''}</span>
        </p>
        <MarkdownComponent markdown={pageContent?.jobdescription || ''} />
        <ButtonPrimary
          className="mx-auto mt-12"
          label="Apply now"
          link={pageContent?.typeformlink || ''}
        />
      </Section>
      <RecommendedDocuments
        recommendations={recommendations}
        config={pageConfig.recommendedConfig}
      />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await getPagePropsBySlug(context, '/jobs', {
    with_recommendations: true
  })
}

export default JobPage
